import { render, staticRenderFns } from "./invoiceList.vue?vue&type=template&id=52822e3e&scoped=true"
import script from "./invoiceList.vue?vue&type=script&lang=js"
export * from "./invoiceList.vue?vue&type=script&lang=js"
import style0 from "./invoiceList.vue?vue&type=style&index=0&id=52822e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52822e3e",
  null
  
)

export default component.exports